<template>
  <b-img
    style="max-height:32px;"
    :src="appLogoImage"
    alt="logo"
  />
</template>

<script>
import { $themeConfig } from '@themeConfig'

export default {
  components: {
  },
  setup() {
    const { appLogoImage } = $themeConfig.app
    return {
      appLogoImage,
    }
  },
}
</script>
